// src/components/SinisterCardData/SinisterSectionList.tsx
import { Box, Divider, Grid, Typography } from "@mui/material";
import { SectionConfigSinister } from "../../types/fieldsconfig";
import InfoItemWithCopy from "../../../../shared/components/InfoItemWithCopy/InfoItemWithCopy";

interface SinisterSectionListProps {
	sections: SectionConfigSinister[];
}

const SinisterSectionList = ({ sections }: SinisterSectionListProps) => {
	return (
		<>
			{sections.map((section, sectionIndex) => (
				<div key={sectionIndex} style={{ marginBottom: "16px" }}>
					<Typography
						variant="h6"
						sx={{
							color: "#4c4c4d",
							fontWeight: 500,
							marginBottom: "12px",
						}}
					>
						{section.title}
					</Typography>
					{section.rows.map((row, rowIndex) => (
						<Grid container spacing={2} sx={{ mb: 2 }} key={rowIndex}>
							{row.fields
								.filter((field) => !field.hidden)
								.map((field, fieldIndex) => (
									<Grid item xs={field.colSpan || 12} sm={field.colSpan || 6} key={fieldIndex}>
										<InfoItemWithCopy
											label={field.label || ""}
											value={field.valueFormatter ? field.valueFormatter(field.value || "") : field.value || ""}
											icon={field.icon}
											image={field.image}
											additionalInfo={field.additionalInfo}
										/>
									</Grid>
								))}
						</Grid>
					))}
					{sectionIndex < sections.length - 1 && <Divider sx={{ my: 3 }} />}
				</div>
			))}
		</>
	);
};

export default SinisterSectionList;
